import type {PayloadAction, WritableDraft} from '@reduxjs/toolkit';
import type {CodeListMap} from 'schemaDefinition/types';
import type {ManifestationV4, MetadataEditState} from '../types';
import {
  assertManifestation,
  assertMetadata,
  getMetadataOrder,
  replaceManifestationData,
  updateEditStatusOnEdit,
  updateManifestationExportProps,
} from '../functions';
import type {MetadataEditAction_ManifestationEdited} from '../metadataEditActionTypes';

export const metadataEditManifestationEditedReducer = (
  state: WritableDraft<MetadataEditState>,
  action: PayloadAction<{
    manifestation: ManifestationV4;
    codelists: CodeListMap;
  }>,
) => {
  const originalAction: MetadataEditAction_ManifestationEdited = {
    type: 'METADATAEDIT_MANIFESTATION_EDITED',
    payload: action.payload.manifestation,
  };

  const savedManifestation = assertManifestation(
    action.payload.manifestation.id,
    state.savedMetadata,
    originalAction,
    'saved',
  );
  const currentMetadata = assertMetadata(
    state.metadata,
    originalAction,
    'edit',
  );
  const currentStatus = state.editStatuses[action.payload.manifestation.id];

  const newMetadata = replaceManifestationData(
    action.payload.manifestation,
    currentMetadata,
  );

  const newManifestation = assertManifestation(
    action.payload.manifestation.id,
    newMetadata,
    originalAction,
    'edit',
  );

  state.metadata = newMetadata;
  if (currentStatus?.hasMoved) {
    state.order = getMetadataOrder(
      newMetadata,
      state.newExpressionIds,
      action.payload.codelists,
    );
  }

  state.editStatuses = updateEditStatusOnEdit(
    savedManifestation,
    newManifestation,
    state.editStatuses,
  );
  state.exports = updateManifestationExportProps(
    newManifestation,
    state.exports,
  );
};
